import type { useScroll } from './useScroll'
import { createContext } from 'react'

type ScrollContextType = ReturnType<typeof useScroll>

export const ScrollContext = createContext<ScrollContextType | undefined>(undefined)
